import React, { useEffect } from "react";
import styles from "../styles/components/MyCharactersGridItem.module.css";
import DeleteButton from "./DeleteButton";
import useApi from "../hooks/useApi";

import { useDispatch, useSelector } from "react-redux";
import { startCharacterPolling } from "../reducers/characterSlice";
import StatusIndicator from "./StatusIndicator";

const MyCharactersGridItem = ({ item, selected, onClick, onDelete }) => {
  const { get } = useApi();

  const dispatch = useDispatch();

  const { items, status } = useSelector((state) => state.characters);
  const characterData = items.find((char) => char.id === item.id);

  useEffect(() => {
    if (status === "succeeded") {
      if (characterData && characterData.processing) {
        console.log("Processing is true. Dispatching to update character...");

        const id = item.id;
        dispatch(startCharacterPolling({ id, get }));
      }
    }
  }, [characterData, dispatch, get, item.id, status]);

  return (
    <div className={selected ? styles.gridItemSelected : styles.gridItem} onClick={onClick}>
      {item.thumbnail ? (
        <img src={item.thumbnail} alt={`Thumbnail ${item.id}`} />
      ) : (
        <div className={styles.loaderContent}>
          {item.processing &&
            <div className={styles.loader}></div>
          }
        </div>
      )}

      {onDelete && <DeleteButton onDelete={onDelete} />}

      <StatusIndicator item={item} />
    </div>
  );
};

export default MyCharactersGridItem;
